import { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import useLoginLogout from "../../../hooks/AuditLogReports/useLoginLogout";
import { AuditLogReportRequest, LoginLogoutRow } from '../../../model/auditlogreports';
import exportFromJSON from 'export-from-json';
import { Grid, Stack } from '@mui/material';
import ReportHeader from './ReportHeader';
import ReportToolbar from './ReportToolbar';

const LoginLogout = ({ request, reportType, filterBy, users }: props) => {

    const { status, data, error, isFetching } = useLoginLogout(request);
    
    const columns = [
        {
            name: 'User Name',
            selector: (row: LoginLogoutRow) => row.userName,
        },
        {
            name: 'Date',
            selector: (row: LoginLogoutRow) => row.date,
        },
        {
            name: 'Time Log-in',
            selector: (row: LoginLogoutRow) => row.timeLogIn,
        },
        {
            name: 'Time Log-out',
            selector: (row: LoginLogoutRow) => row.timeLogOut,
        },
        {
            name: 'Total Hours',
            selector: (row: LoginLogoutRow) => row.totalHours,
        },
        {
            name: 'IP Address',
            selector: (row: LoginLogoutRow) => row.ipAddress,
        }
    ];
    const conditionalRowStyles = [
        {
            when: (row: any) => row.type == 'Summary',
            style: {
                fontWeight: 'bold'
            },
        },
    ];

    const exportLoginLogoutData = () => {
        const reportData = data || [];
        const fileName = 'LoginLogout';
        const exportType = exportFromJSON.types.csv;
        const fields = { userName: 'User Name', date: 'Date', timeLogIn: 'Time Log-in', timeLogOut: 'Time Log-out', totalHours: 'Total Hours', ipAddress: 'IP Address' };

        exportFromJSON({
            data: reportData,
            fileName: fileName,
            fields: fields,
            exportType: exportType
        });
    };

    return (
        <Fragment>
            <Grid container>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={6}>
                    <ReportHeader reportType={reportType} filterBy={filterBy} users={users} />
                </Grid>
                <Grid item xs={1}>
                    <ReportToolbar export={exportLoginLogoutData} />
                </Grid>
            </Grid>
            <DataTable
                columns={columns}
                data={data || []}
                conditionalRowStyles={conditionalRowStyles}
                fixedHeader={true}
                fixedHeaderScrollHeight={'750px'}
                pagination
            />
        </Fragment>
    );
}

type props = {
    request: AuditLogReportRequest;
    reportType: any
    filterBy: any
    users: any
}

export default LoginLogout;